export default __webpack_public_path__ + "assets/Patent_PRArtcile.193f5e5b.jpg";